import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Box, CircularProgress } from "@mui/material";
import { API } from "aws-amplify";
import { toast } from "react-toastify";

function MeasureRedirect() {
    const history = useHistory();
    const { dashboardId } = useParams();

    useEffect(() => {
        let cancelled = false;

        API.get('Core', '/api/v1/analytics/dashboard')
            .then(response => {
                if (cancelled) return;
                const list = response || [];
                const match = dashboardId
                    ? list.find(d => d.dashboardId === dashboardId)
                        || list.find(d => d.quicksightId === dashboardId)
                    : null;
                if (match && match.lookerId) {
                    history.replace(`/reports/${match.lookerId}`);
                } else {
                    history.replace('/reports');
                }
            })
            .catch(error => {
                if (cancelled) return;
                toast("Could not resolve dashboard: " + (error?.response?.data?.message || error.message), {
                    position: "top-center",
                    type: "error"
                });
                history.replace('/reports');
            });

        return () => { cancelled = true; };
    }, [dashboardId, history]);

    return (
        <Box style={{ display: 'block', height: '100vh' }}>
            <CircularProgress style={{ position: 'absolute', width: '40px', left: '45vw', top: '45vh' }} />
            <span style={{ position: 'absolute', left: '40vw', top: '55vh' }}>
                Redirecting to Reports...
            </span>
        </Box>
    );
}

export default MeasureRedirect;
